import { render, staticRenderFns } from "./eventSetting.vue?vue&type=template&id=9649c32c&scoped=true"
import script from "./eventSetting.vue?vue&type=script&lang=js"
export * from "./eventSetting.vue?vue&type=script&lang=js"
import style0 from "./eventSetting.vue?vue&type=style&index=0&id=9649c32c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9649c32c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9649c32c')) {
      api.createRecord('9649c32c', component.options)
    } else {
      api.reload('9649c32c', component.options)
    }
    module.hot.accept("./eventSetting.vue?vue&type=template&id=9649c32c&scoped=true", function () {
      api.rerender('9649c32c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/develop/crud/components/eventSetting.vue"
export default component.exports